// extracted by mini-css-extract-plugin
export default {"formHeading":"XH-z","form":"YH-z","submitBtn":"ZH-z","disabled":"_H-z","input":"aI-z","error":"bI-z","submitMsg":"cI-z","signIn":"dI-z"};